// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISignUpRequestDto
 */
export interface ISignUpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ISignUpRequestDto
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ISignUpRequestDto
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ISignUpRequestDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ISignUpRequestDto
     */
    unique_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ISignUpRequestDto
     */
    phone_number?: string;
    /**
     * 
     * @type {Date}
     * @memberof ISignUpRequestDto
     * @deprecated
     */
    birth_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ISignUpRequestDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof ISignUpRequestDto
     */
    registration_code?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ISignUpRequestDto
     */
    is_electronic_statement_only?: boolean;
}

/**
 * Check if a given object implements the ISignUpRequestDto interface.
 */
export function instanceOfISignUpRequestDto(value: object): value is ISignUpRequestDto {
    return true;
}

export function ISignUpRequestDtoFromJSON(json: any): ISignUpRequestDto {
    return ISignUpRequestDtoFromJSONTyped(json, false);
}

export function ISignUpRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISignUpRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
        'email': json['email'] == null ? undefined : json['email'],
        'unique_id': json['unique_id'] == null ? undefined : json['unique_id'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'birth_date': json['birth_date'] == null ? undefined : (new Date(json['birth_date'])),
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'registration_code': json['registration_code'] == null ? undefined : json['registration_code'],
        'is_electronic_statement_only': json['is_electronic_statement_only'] == null ? undefined : json['is_electronic_statement_only'],
    };
}

export function ISignUpRequestDtoToJSON(json: any): ISignUpRequestDto {
    return ISignUpRequestDtoToJSONTyped(json, false);
}

export function ISignUpRequestDtoToJSONTyped(value?: ISignUpRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'password': value['password'],
        'email': value['email'],
        'unique_id': value['unique_id'],
        'phone_number': value['phone_number'],
        'birth_date': value['birth_date'] == null ? undefined : ((value['birth_date']).toISOString()),
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'registration_code': value['registration_code'],
        'is_electronic_statement_only': value['is_electronic_statement_only'],
    };
}

